import { useToast } from '@kanda-libs/ks-design-library';
import { actions } from '@kanda-libs/ks-frontend-services';
import { useAppDispatch } from 'components/App';
import useApiError from 'hooks/useApiError';
import { useLeadContext } from 'pages/Lead/context';
import { useCallback } from 'react';

export interface LeadUnarchiveHook {
  onClick: () => void;
  isSubmitting: boolean;
}

export default function useLeadUnarchive(): LeadUnarchiveHook {
  const { id, isSubmitting, setIsSubmitting } = useLeadContext();
  const dispatch = useAppDispatch();
  const { showSuccess } = useToast();
  const onError = useApiError('Unknown error unarchiving lead');

  const onClick = useCallback(() => {
    if (!id) return;
    setIsSubmitting(true);
    dispatch(
      actions.postEnquiryUnarchive({
        params: { id },
        onError: (err) => {
          setIsSubmitting(false);
          onError(err);
        },
        onSuccess: () => {
          setIsSubmitting(false);
          showSuccess('Unarchived lead');
        },
      }),
    );
  }, [id, dispatch, onError, showSuccess, setIsSubmitting]);

  return {
    onClick,
    isSubmitting,
  };
}
